module.exports = __webpack_public_path__ + "static/media/banner-left-arrow.ed5df834.svg";